import {Component, Inject, OnInit, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {appearSlowlyAnimation} from "src/app/features/cookie-modal/cookie-modal-animation";
import {DeviceDetectService} from "../../../services/device-detect.service";
import { NgClass, UpperCasePipe } from "@angular/common";
import {
  PageContentHeaderComponent,
} from "../../../shared/components/page-content-header/page-content-header.component";
import {LinkHandlerDirective} from "../../../directives/link-handler.directive";

@Component({
    selector: "app-extra-terms-modal",
    templateUrl: "./extra-terms-modal.component.html",
    styleUrls: ["./extra-terms-modal.component.css"],
    animations: [appearSlowlyAnimation],
  imports: [
    NgClass,
    UpperCasePipe,
    TranslateModule,
    PageContentHeaderComponent,
    LinkHandlerDirective
]
})
export class ExtraTermsModalComponent implements OnInit {
  showModal: boolean;
  disappear: boolean;
  showButtons: boolean = true;
  showBackButton: boolean = false;
  content: string;
  isMobile: boolean;

  constructor(
    private dialogRef: MatDialogRef<ExtraTermsModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    private translate: TranslateService,
    private deviceDetect: DeviceDetectService,
  ) {
    this.isMobile = deviceDetect.isMobile;
  }

  ngOnInit(): void {
    this.content = this.translate.instant(this.data);
    if (this.router.url.endsWith("consents")) {
      this.dialogRef.disableClose = false;
      this.showButtons = false;
      this.showBackButton = true;
    }
    setTimeout(() => {
      this.showModal = true;
    }, 1000);
    setTimeout(() => {
      this.disappear = false;
    }, 1000);
  }

  onAccept() {
    setTimeout(() => {
      this.disappear = true;
    }, 0);

    setTimeout(() => {
      this.dialogRef.close("true");
    }, 1000);
  }

  onNotAccept() {
    this.disappear = true;
    setTimeout(() => {
      this.dialogRef.close("false");
    }, 100);
  }

  onClose() {
    this.disappear = true;
    this.dialogRef.close();
  }

}
